__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "react_box_0_1_13";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] ||= {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@kne/current-lib_react-box", "0.1.13", () => (Promise.all([__webpack_require__.e(227), __webpack_require__.e(922), __webpack_require__.e(807)]).then(() => (() => (__webpack_require__(333807))))));
			register("@kne/global-context", "1.3.2", () => (Promise.all([__webpack_require__.e(884), __webpack_require__.e(175)]).then(() => (() => (__webpack_require__(905175))))));
			register("@kne/global-context", "1.3.2", () => (Promise.all([__webpack_require__.e(922), __webpack_require__.e(552)]).then(() => (() => (__webpack_require__(660171))))));
			register("@kne/react-fetch", "1.5.7", () => (Promise.all([__webpack_require__.e(46), __webpack_require__.e(240), __webpack_require__.e(884)]).then(() => (() => (__webpack_require__(185240))))));
			register("@kne/react-fetch", "1.5.7", () => (Promise.all([__webpack_require__.e(506), __webpack_require__.e(922)]).then(() => (() => (__webpack_require__(754506))))));
			register("@kne/react-intl", "0.1.15", () => (Promise.all([__webpack_require__.e(507), __webpack_require__.e(884), __webpack_require__.e(558), __webpack_require__.e(694)]).then(() => (() => (__webpack_require__(500507))))));
			register("@kne/react-intl", "0.1.15", () => (Promise.all([__webpack_require__.e(439), __webpack_require__.e(922), __webpack_require__.e(97)]).then(() => (() => (__webpack_require__(203439))))));
			register("@kne/remote-loader", "1.4.6", () => (Promise.all([__webpack_require__.e(46), __webpack_require__.e(884), __webpack_require__.e(143)]).then(() => (() => (__webpack_require__(388524))))));
			register("@kne/responsive-utils", "0.1.16", () => (Promise.all([__webpack_require__.e(884), __webpack_require__.e(975)]).then(() => (() => (__webpack_require__(499356))))));
			register("antd", "6.6.5", () => (Promise.all([__webpack_require__.e(171), __webpack_require__.e(884), __webpack_require__.e(486), __webpack_require__.e(469), __webpack_require__.e(286)]).then(() => (() => (__webpack_require__(21171))))));
			register("antd", "6.6.5", () => (Promise.all([__webpack_require__.e(386), __webpack_require__.e(647), __webpack_require__.e(922), __webpack_require__.e(388)]).then(() => (() => (__webpack_require__(389647))))));
			register("axios", "1.20.0", () => (__webpack_require__.e(632).then(() => (() => (__webpack_require__(611632))))));
			register("dayjs", "1.11.23", () => (__webpack_require__.e(845).then(() => (() => (__webpack_require__(96845))))));
			register("dayjs", "1.11.23", () => (__webpack_require__.e(649).then(() => (() => (__webpack_require__(397649))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(901), __webpack_require__.e(884)]).then(() => (() => (__webpack_require__(925901))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(817), __webpack_require__.e(922)]).then(() => (() => (__webpack_require__(946817))))));
			register("react-router-dom", "6.30.6", () => (Promise.all([__webpack_require__.e(108), __webpack_require__.e(884), __webpack_require__.e(486)]).then(() => (() => (__webpack_require__(386108))))));
			register("react", "18.3.1", () => (__webpack_require__.e(888).then(() => (() => (__webpack_require__(252888))))));
			register("react", "18.3.1", () => (__webpack_require__.e(84).then(() => (() => (__webpack_require__(957084))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};